import React from 'react';
import { Accordion } from './Accordion';
import { CTAButton } from './CTAButton';
import { modules } from '../data/content';
export function Modules() {
  return <section className="px-5 py-8" aria-labelledby="modulos-title" data-id="element-155" data-mp="1r3zdftpixx6o">
      <p className="text-center text-[12px] font-semibold uppercase tracking-widest text-[#6f8f7c]" data-id="element-156" data-mp="1vxludy2q0n8a">
        Para eso hemos preparado
      </p>

      <h2 id="modulos-title" className="mt-2 text-center font-display text-[26px] leading-tight text-[#16302a]" data-id="element-157" data-mp="145w8tqy55j08">
        Gimnasia Postural Resuelta
      </h2>
      <p className="mt-2 text-center text-[14px] text-[#3d4f47]" data-id="element-158" data-mp="187zsh2uyrtwl">
        📚 Formación completa para profesionales de la gimnasia postural
      </p>

      <div className="mt-6" data-id="element-159" data-mp="1i5dwu43m4s8j">
        <Accordion data={modules} data-id="element-160" data-mp="1i6gpaggl32qk" />
      </div>

      <div className="mt-6" data-id="element-161" data-mp="1i3b2x8zcaeyj">
        <CTAButton label="Acceder a los 6 tomos" data-id="element-162" data-mp="2omizezhx8nj3" />
      </div>
    </section>;
}